import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-responsive m-n3 rounded" }
const _hoisted_2 = { class: "table mb-0" }
const _hoisted_3 = {
  scope: "col",
  class: "text-center align-middle"
}
const _hoisted_4 = { class: "p-2 m-n3" }
const _hoisted_5 = ["onChange", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", { scope: "col" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createElementBlock("th", _hoisted_3, _toDisplayString(_ctx.$t(`parameters.${_ctx.parameterId}.options.${column}`)), 1))
          }), 256))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("th", {
              scope: "row",
              class: _normalizeClass({'border-0': index === _ctx.rows.length - 1})
            }, _toDisplayString(_ctx.$t(`parameters.${_ctx.parameterId}.rows.${row}`)), 3),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
              return (_openBlock(), _createElementBlock("td", {
                class: _normalizeClass([{'border-0': index === _ctx.rows.length - 1}, "text-center"])
              }, [
                _createElementVNode("label", _hoisted_4, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    onChange: ($event: any) => (_ctx.onChecked(row, column, $event.target.checked)),
                    checked: _ctx.isChecked(row, column)
                  }, null, 40, _hoisted_5)
                ])
              ], 2))
            }), 256))
          ]))
        }), 256))
      ])
    ])
  ]))
}